/* esm.sh - mainnet-js@4.0.0-next.4/dist/module/util/sanitizeUnit */
function t(e){if(e)return e.toLocaleLowerCase();throw Error("Attempted to sanitize a unit of value, but the unit was undefined.")}export{t as sanitizeUnit};
//# sourceMappingURL=sanitizeUnit.mjs.map